import 'babel-polyfill';
import 'whatwg-fetch';
import 'url-search-params-polyfill';
import 'intersection-observer';
import '../scss/common.scss';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import ReactModal from 'react-modal';
import reducer from './modules/index';
import apolloClient from './queries';
import 'react-datepicker/dist/react-datepicker.css';

import App from './components/App';

ReactModal.setAppElement('#app');

const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActionPaths: ['payload.onClose'],
      ignoredPaths: [
        'app.onCloseErrorModal',
        // 'flight.flightsInput.outbound.date',
        // 'flight.flightsInput.inbound.date',
        // 'flight.searchedFlightsInput.outbound.date',
        // 'flight.searchedFlightsInput.inbound.date',
      ],
    }
  })
});

render(
  <ApolloProvider client={apolloClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>,
  document.getElementById('app')
);
